export default __webpack_public_path__ + "static/media/Icons_External_Link_Bold.6b5a9561.svg";